<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{op=='add'?$t("add_sub") + "(" + func_pcname + ")":$t("upd") + "(" + func_pcname + ")"}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('cname')" prop="func_cname">
                        <el-input v-model="formData.func_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('code')" prop="func_code">
                        <el-input v-model="formData.func_code" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('web_url')" prop="web_url">
                        <el-input v-model="formData.web_url" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('wxmp_url')" prop="wxmp_url">
                        <el-input v-model="formData.wxmp_url" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('cdesc')" prop="func_cdesc">
                        <el-input v-model="formData.func_cdesc" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('cat')" prop="cat_id">
                        <el-select class="fillw" v-model="formData.cat_id" :placeholder="$t('select')">
                            <el-option :value="item.key" :label="item.value" v-for="item in cat_id" :key="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="IVIEW 图标" prop="icon">
                        <el-input v-model="formData.icon" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('icon_color')" prop="color">
                        <el-input v-model="formData.color" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="自定义图标" prop="img_lnk">
                        <div class="flex-box nopadding" v-if="formData.img_lnk != ''">
                            <div class="bg-black pd-5"><img class="width-50" style="display: inherit" :src="formData.img_lnk"></div>
                            <a class="f-red mg-left5" @click="formData.img_lnk = ''"><Icon size="24" type="md-backspace" /></a>
                        </div>
                        <div class="flex-box nopadding">
                            <myUpImg @onChange="setImgLnk" :lrz_flag="false"></myUpImg>
                            <div class="mg-left10 f12 f-gray">建议尺寸 48px * 48px</div>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('sort')" prop="sort_id">
                        <el-input v-model="formData.sort_id" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="s1_flag" :label="$t('s1_flag')">
                        <el-radio-group v-model="formData.s1_flag" :disabled="op == 'upd'">
                            <el-radio v-for="item in yes_no" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="s2_flag" :label="$t('s2_flag')">
                        <el-radio-group v-model="formData.s2_flag" :disabled="op == 'upd'">
                            <el-radio v-for="item in yes_no" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="s3_flag" :label="$t('s3_flag')">
                        <el-radio-group v-model="formData.s3_flag" :disabled="op == 'upd'">
                            <el-radio v-for="item in yes_no" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="op == 'upd'">
                <el-col :span="12"><el-form-item :label="$t('add_user')"><el-input v-model="formData.add_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('add_time')"><el-input v-model="formData.add_time" disabled></el-input></el-form-item></el-col>
            </el-row>
            <el-row v-if="op == 'upd'">
                <el-col :span="12"><el-form-item :label="$t('upd_user')"><el-input v-model="formData.upd_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('upd_time')"><el-input v-model="formData.upd_time" disabled></el-input></el-form-item></el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
import myUpImg from "../../components/myUpImg";
export default {
    components:{
        myUpImg
    },
    data:function(){
        return{
            op: this.$base.getRequest().op,
            relist: false,
            func_pcname:'',
            formData: {
                func_id:'',
                func_code: '',
                sort_id: 99,
                func_cname : '',
                func_cdesc : '',
                web_url: '',
                wxmp_url: '',
                img_lnk: '',
                icon: '',
                color: '',
                cat_id:'',
                s1_flag:'',
                s2_flag:'',
                s3_flag:'',
                add_user:'',
                add_time:'',
                upd_user:'',
                upd_time:'',
            },
            rule: {
                func_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                sort_id: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                func_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                func_cdesc: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                cat_id: [{required: true, message: this.$t('select'), trigger: 'chang'}],
                s1_flag: [{required: true, message: this.$t('select'), trigger: 'chang'}],
                s2_flag: [{required: true, message: this.$t('select'), trigger: 'chang'}],
                s3_flag: [{required: true, message: this.$t('select'), trigger: 'chang'}]
            },
            yes_no:[],
            cat_id:[],
        }
    },
    computed:{
    },
    mounted: function(){
        this.$parent.$parent.show_subview = true;
        var para = this.$base.getRequest();
        this.formData.func_id = para.id;
        this.func_pcname = para.func_pcname;


        if(!this.formData.func_id){
            this.getLoad();
        }
        else{
            this.getInfo();
        }
    },
    methods:{
        cancel: function(){
            this.$base.linkBack();
        },
        setImgLnk (data) {
            this.formData.img_lnk = data.url;
        },
        getLoad: function(){
            this.$base.showLoading();
            this.$request.sendPost("func/before-add",{},(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.yes_no = data.yes_no;
                    this.cat_id = data.cat_id;
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        getInfo: function(){
            var data = {
                func_id: this.formData.func_id
            };
            this.$base.showLoading();
            this.$request.sendPost("func/before-upd",data,(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.yes_no = data.yes_no;
                    this.cat_id = data.cat_id;
                    this.formData = this.$base.leftJson(this.formData, data.info);
                    this.formData.func_type = data.info.func_type
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        submit: function(){
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    var url = this.op=='upd'?"func/upd":"func/add";

                    this.$base.showLoading();
                    this.$request.sendPost(url,this.formData,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.$base.msgSuccess(error.errmsg);
                            this.relist = true;
                            this.$base.linkBack();
                        }
                        else{
                            this.$base.alertErr(error.errmsg);
                        }
                    });
                } else {
                    this.$base.alertErr(this.$t('incomplete'));
                }
            })
        }
    },
    beforeDestroy: function () {
        this.$parent.$parent.show_subview = false;
        this.$parent.$parent.relist = this.relist;
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/func_save.vue